import React from "react";
import { useNavigate } from "react-router-dom";
import { Cloud, Phone } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const cols = [
  { title: "Product", links: [["How it works", "manifesto"], ["Why Advanced Life Policies", "why"], ["Full application", "/apply"], ["FAQ", "faq"]] },
  { title: "Company", links: [["About", "hero"], ["Our promise", "why"], ["Reviews", "testimonials"], ["Get started", "signup"], ["Log in", "/admin"]] },
];

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="bg-forest text-cream/80 pt-16 pb-10" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-10 md:grid-cols-12 border-b border-cream/10 pb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="block w-10 h-10 rounded-full bg-cream text-forest grid place-items-center ring-1 ring-cream/20">
                <span className="font-serif italic text-lg leading-none">A</span>
              </span>
              <span className="font-serif text-2xl text-cream">Advanced Life Policies</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/60">
              Insurance, tax, and planning under one roof. A quietly rigorous team looking
              after the money that shapes your life — for the long haul.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-forest-700/60 border border-cream/10 px-4 py-2 text-xs text-cream/70">
              <Cloud className="h-4 w-4 text-sage-light" /> Clear skies for every plan started
            </div>
            <a
              href="tel:+19179053568"
              data-testid="footer-phone"
              className="mt-5 flex items-center gap-2.5 text-cream/85 hover:text-cream transition-colors"
            >
              <span className="grid place-items-center h-9 w-9 rounded-full bg-forest-700/60 border border-cream/10">
                <Phone className="h-4 w-4 text-sage-light" />
              </span>
              <span>
                <span className="block text-[11px] uppercase tracking-[0.16em] text-cream/50">Talk to an advisor</span>
                <span className="block font-serif text-xl">(917) 905-3568</span>
              </span>
            </a>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-3 md:col-start-auto">
              <p className="text-xs uppercase tracking-[0.18em] font-bold text-sage-light">{c.title}</p>
              <ul className="mt-4 space-y-3">
                {c.links.map(([label, id]) => (
                  <li key={label}>
                    <button
                      onClick={() => (id.startsWith("/") ? navigate(id) : scrollTo(id))}
                      className="text-sm text-cream/70 hover:text-cream transition-colors"
                      data-testid={`footer-link-${label.replace(/\s+/g, "-").toLowerCase()}`}
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-cream/45">
          <p>© {new Date().getFullYear()} Advanced Life Policies. All rights reserved.</p>
          <p className="max-w-md">
            *Illustrative estimates only. Advanced Life Policies is a demonstration brand; figures shown are not a
            binding offer of insurance. No medical exam applies to most standard applications.
          </p>
        </div>
      </div>
    </footer>
  );
}
